// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"706823abfe1e7f02","454":"f3ffe629e6cea3b0"}[chunkId] + ".css";
};